import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpInterceptorFn,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { environment } from "@environments/environment";
import { inject } from "@angular/core";

// Type alias for casting if needed frequently
type EnvironmentType = typeof environment;

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly API_URL = (environment as EnvironmentType).apiUrl || "";

  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Only add the auth token to requests to our API
    if (request.url.startsWith(this.API_URL)) {
      const token = this.authService.getAccessToken();

      if (token) {
        // Clone the request and add the token
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
    }

    // Pass the modified request to the next handler
    return next.handle(request);
  }
}

// Export a standalone interceptor function for use with withInterceptors
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const API_URL = (environment as EnvironmentType).apiUrl || "";

  // Only add the auth token to requests to our API
  if (req.url.startsWith(API_URL)) {
    const token = authService.getAccessToken();

    if (token) {
      // Clone the request and add the token
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
  }

  // Pass the modified request to the next handler
  return next(req);
};
